export const BuildInfo = {timestamp:1783613879000}
